import React, { useState, useEffect } from "react";
import classes from "./login.module.css";
import Input from "./Input";
import Button from "./button";
import Link from "./link";
import { notification } from "antd";
import Validation from "../utils/validation";
import axios from "../../Axios";
import { useHistory } from "react-router-dom";
const intialState = {
  email: null,
  password: null,
};

const openNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message: `${message}`,
    description: `${description}`,
  });
};
const initialError = {
  email: false,
  password: false,
};
const Login = ({ setAuth }) => {
  const history = useHistory();
  const [state, setState] = useState({ ...intialState });
  const [errors, setErrors] = useState({ ...initialError });
  const [loading, setLoading] = useState(false);
  const { email, password } = state;

  const [isInValid, setIsInValid] = useState(false);

  useEffect(() => {
    //err handeling

    if (
      email === null ||
      password === null ||
      errors.email ||
      errors.password
    ) {
      setIsInValid(true);
    } else setIsInValid(false);
  }, [state, errors, email, password]);

  const clickHandler = (e) => {
    e.preventDefault();
    setLoading(true)
    
    axios
      .post("/admin/login", state)
      .then((res) => {
        const { data } = res;
        setLoading(false);
        if (data.verify) {
          localStorage.setItem("currentEmail", email);
          openNotificationWithIcon(
            "success",
            "Otp",
            `You are not verified. An OTP has been sent to ${email}. Enter OTP to get verified`
          );
          history.push("/verify");
        } else if (data.auth) {
          
          const { token, user, name, company } = data.payload;
          localStorage.setItem("token", token);
          localStorage.setItem("user", user);
          localStorage.setItem("name", name);
          localStorage.setItem("company", company);
          setAuth(true);
          history.push("/");
        } else {
          openNotificationWithIcon(
            "error",
            "Login Failed",
            `Login failed due to ${data.message}`
          );
        }
      })
      .catch((err) => {
        setTimeout(()=> setLoading(false), 3000)
        openNotificationWithIcon(
          "error",
          "Login Failed",
          `Login failed due to ${err}`
        );
      });
  };

  const changeHandler = (e) => {
    let { name, value } = e.target;

    let inputValid = false;
    if (name === "email") {
      if (Validation().email(value)) inputValid = true;
    } else if (name === "password") {
      if (Validation().passwordOnLog(value)) inputValid = true;
    }
    setErrors(() => ({ ...errors, [name]: !inputValid }));
    if (value.trim() === "") value = null;

    setState(() => ({ ...state, [name]: value }));
  };
  return (
    <>
      <h1 className={classes.login}>Welcome</h1>
      <span className={classes.text}>
        To your Digital Audit Reports, Anytime Anywhere.
      </span>

      <Input
        onChange={changeHandler}
        name="email"
        err={errors["email"]}
        errMsg="Please enter a valid email address"
        value={email===null?'':email}
        type="email"
        HolderClass={classes.input}
        placeholder="e-mail"
      />

      <Input
        onChange={changeHandler}
        name="password"
        err={errors["password"]}
        errMsg="Password must be 5 charachter long"
        value={password===null?'':password}
        type="password"
        HolderClass={classes.input}
        placeholder="password"
      />

      <Link href="/forgot-password" extraClass={classes.link}>
        Forgot Password?
      </Link>

      <Button
        onClick={clickHandler}
        extraClass={classes.button}
        disabled={isInValid}
        isLoading={loading}
      >
        Sign in
      </Button>

      <div className={classes.block}>
        <span className={classes.span}>New User? </span>
        <Link
          extraClass={[classes.link, classes.linkTwo].join(" ")}
          href="/register"
        >
          {" "}
          Click Here
        </Link>
      </div>
    </>
  );
};

export default Login;
